import { useQuery } from "@tanstack/react-query";
import { GetPortalDevicesResponse } from "@queries/Devices";
import { useState } from "react";
/* 
import { licenseApis } from "@queries/License";
import { generateDevicesInformation } from "@hooks/common/util";
import {
  AllPortalDevices,
  PortalDeviceWithLinkedLicenses
} from "@custom-types/Types";
import { ON_CLOUD_STATUS, WAVE_SYNC_STATUS } from "@resources/Constants";
*/
import { useGetPortalDevicesQuery } from "@queries/tanstack/device/DeviceQuery";
import { AllPortalDevices } from "@custom-types/Types";

export const useDevicesWithLinkedLicenses = (
  orgId: string,
  queryOptions?: Parameters<typeof useQuery>[2]
) => {
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  /* Wave sync not in use in this hook, but included for future use 
  const {
    waveSyncDevices,
    refetchWaveSyncData,
    isLoadingWaveSyncLinkedStatus
  } = useWaveSyncData(queryOptions);
  */

  const {
    data: allDevices,
    refetch: refetchAllDevices,
    isLoading: isLoadingDevices
    // isError: isDeviceLoadingError
  } = useGetPortalDevicesQuery(
    { orgId, sightmindStatus: true },
    {
      enabled: !!orgId,
      ...(queryOptions as GetPortalDevicesResponse)
    }
  );

  /*  not in use as we are not using wave sync or oncloud
  const convertedAllDevices = useMemo(
    () =>
      (allDevices as GetPortalDevicesResponse)?.map(
        (device) =>
          ({
            ...device
          }) as unknown as PortalDeviceWithLinkedLicenses
      ),
    [allDevices]
  );

  const {
    data: licenseList,
    refetch: refetchLicenseList,
    isLoading: isLoadingLicenses,
    isLoadingError: isLicenseLoadingError
  } = useQuery({
    queryKey: ["license-list"],
    queryFn: () => licenseApis.getLicenseList({ orgId, status: ["ALL"] }),
    enabled: !!orgId,
    staleTime: 5000,
    ...(queryOptions as GetPortalDevicesResponse)
  });
   */

  const reloadAllData = async () => {
    setIsRefreshing(true);

    const response = await Promise.allSettled([
      refetchAllDevices()
      // refetchLicenseList()
      // refetchWaveSyncData()
    ]);

    setIsRefreshing(false);
    return !!response;
  };

  /*  not in use as we are not using wave sync or oncloud
  const allDevicesWithLinkedLicences = useMemo(() => {
    if (
      isRefreshing ||
      isLoadingDevices ||
      isLoadingLicenses
      isLoadingWaveSyncLinkedStatus
    )
      return [];

    return generateDevicesInformation<AllPortalDevices>(
      isDeviceLoadingError ? [] : convertedAllDevices || [],
      isLicenseLoadingError ? [] : licenseList || []
    );
  }, [
    convertedAllDevices,
    isDeviceLoadingError,
    isLicenseLoadingError,
    isLoadingDevices,
    isLoadingLicenses,
    isRefreshing,
    licenseList
  ]);
  */

  return {
    allDevicesWithLinkedLicenses:
      (allDevices as unknown as AllPortalDevices[]) || [],
    isLoading:
      // isLoadingWaveSyncLinkedStatus ||
      // isLoadingLicenses ||
      isLoadingDevices || isRefreshing,
    reloadAllData
  };
};
